/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React, { useEffect, useState } from 'react';
import { Text, View } from 'react-native';
import { styles } from '../ReportsScreen.styles';
import { spacing } from '../../../shared/theme/spacing';
import { ReportsDenseListCard } from './ReportsDenseListCard';
import { ReportsBlockHeading } from './ReportsBlockHeading';
import { ReportsLoadErrorRow } from './ReportsLoadErrorRow';
import { useSessionStore } from '../../../shell/session/store/useSessionStore';
import { supabase } from '../../../shared/supabase/supabaseClient';
import { ticketColors } from '../../../shared/theme/ticketColors';

type ConversionRow = {
  views: number;
  orders_created: number;
  conversion_pct: number;
};

export function CatalogViewsSection({ from, to }: { from: string; to: string }) {
  const currentBranchId = useSessionStore((s) => s.currentBranchId);
  const [row, setRow] = useState<ConversionRow | null>(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);
  const [reloadTick, setReloadTick] = useState(0);

  useEffect(() => {
    if (!currentBranchId) return;
    setLoading(true);
    setLoadError(false);
    Promise.resolve(
      supabase
        .rpc('reports_catalog_view_conversion', {
          p_branch_id: currentBranchId,
          p_from: from,
          p_to: to,
        })
        .then(({ data, error }) => {
          if (error) {
            console.warn('CatalogViewsSection', error);
            setRow(null);
            setLoadError(true);
            return;
          }
          const first = Array.isArray(data) ? data[0] : data;
          if (!first) {
            setRow({ views: 0, orders_created: 0, conversion_pct: 0 });
            return;
          }
          setRow({
            views: Number(first.views ?? 0),
            orders_created: Number(first.orders_created ?? 0),
            conversion_pct: Number(first.conversion_pct ?? 0),
          });
        }),
    ).finally(() => setLoading(false));
  }, [currentBranchId, from, to, reloadTick]);

  if (!currentBranchId) return null;

  return (
    <View style={{ marginTop: spacing.md }}>
      <ReportsBlockHeading label="Conversión visita→pedido" />
      <ReportsDenseListCard>
        {loading ? (
          <Text style={styles.caption}>Cargando…</Text>
        ) : loadError ? (
          <ReportsLoadErrorRow
            message="No se pudieron cargar las visitas al catálogo."
            onRetry={() => setReloadTick((t) => t + 1)}
          />
        ) : row ? (
          <>
            <View style={styles.reportsDenseListFieldRow}>
              <Text style={styles.reportsDenseListFieldLabel}>Visitas al catálogo</Text>
              <Text style={styles.reportsDenseListFieldValue}>{row.views}</Text>
            </View>
            <View style={styles.reportsDenseListFieldRow}>
              <Text style={styles.reportsDenseListFieldLabel}>Pedidos creados</Text>
              <Text style={styles.reportsDenseListFieldValue}>{row.orders_created}</Text>
            </View>
            <View
              style={[
                styles.reportsDenseListFieldRow,
                { borderTopWidth: 1, borderTopColor: '#E0E0E0', paddingTop: spacing.xs, marginTop: spacing.xs },
              ]}
            >
              <Text style={styles.reportsDenseListFieldLabel}>De visita a pedido</Text>
              <Text style={[styles.reportsDenseListFieldValue, { color: ticketColors.gold }]}>
                {row.conversion_pct}%
              </Text>
            </View>
            {row.views === 0 ? (
              <Text style={[styles.caption, { marginTop: spacing.xs }]}>
                Sin visitas registradas en el período.
              </Text>
            ) : null}
          </>
        ) : (
          <Text style={styles.caption}>No se pudieron cargar las visitas.</Text>
        )}
      </ReportsDenseListCard>
    </View>
  );
}
